/*
 * @Descripttion:
 * @Author: 苍狼一啸八荒惊
 * @Date: 2024-09-12 10:10:01
 * @LastEditTime: 2025-05-12 08:43:17
 * @LastEditors: sudo_rm_rf
 */
function getCookie(key: string) {
  var arr1 = document.cookie.split('; '); //这里是分号+空格分隔
  for (var i = 0, len = arr1.length; i < len; i++) {
    var arr2 = arr1[i].split('=');
    if (arr2[0] == key) {
      return decodeURI(arr2[1]);
    }
  }
}
// getCookie('age'); //21

function setCookie(key: string, value: string, time: number = 30) {
  var now = new Date();
  // now.setDate(now.getDate() + time);
  now.setMinutes(now.getMinutes() + time);
  document.cookie = key + '=' + value + ';expires=' + now.toGMTString();
}
// setCookie('sex', '男', 10); //sex='男'存cookie十天
// setCookie('sex', '男', 60); //sex='男'存cookie 60分钟

//封装一个删除cookie的方法，就是将cookie的有效时间更改为昨天而已。
function removeCookie(key: string) {
  setCookie(key, '', -1); //调用上面的setCookie方法
}
// removeCookie('sex');

export { getCookie, setCookie, removeCookie };
